
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire30b8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire30b8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9su8u", function(module, exports) {

$parcel$export(module.exports, "SessionManager", () => $6e2e1af2d90304fb$export$415798a788f40554);
$parcel$export(module.exports, "getRootPath", () => $6e2e1af2d90304fb$export$5413f45d031c7806);
const $6e2e1af2d90304fb$export$415798a788f40554 = {
    getUser () {
        const user = localStorage.getItem('englisho_user');
        return user ? JSON.parse(user) : null;
    },
    loginUser (userData) {
        localStorage.setItem('englisho_user', JSON.stringify(userData));
    },
    logoutUser () {
        localStorage.removeItem('englisho_user');
        window.location.href = $6e2e1af2d90304fb$export$5413f45d031c7806() + 'index.html';
    }
};
function $6e2e1af2d90304fb$export$5413f45d031c7806() {
    const path = window.location.pathname;
    if (path.includes('/pages/features/flashcards/')) return '../../../';
    if (path.includes('/pages/features/quizz/')) return '../../../';
    if (path.includes('/pages/features/')) return '../../';
    if (path.includes('/pages/info/')) return '../../';
    if (path.includes('/pages/auth/')) return '../../';
    if (path.includes('/pages/core/')) return '../../';
    return './';
}

});


var $9su8u = parcelRequire("9su8u");
document.addEventListener('DOMContentLoaded', ()=>{
    const startBtn = document.getElementById('startBtn');
    if (startBtn) startBtn.addEventListener('click', ()=>{
        const name = document.getElementById('nameInput').value.trim();
        const age = document.getElementById('ageInput').value.trim();
        if (name === '' || age === '') alert('Please enter both your name and age.');
        else {
            (0, $9su8u.SessionManager).loginUser({
                name: name,
                age: age,
                role: 'Child'
            });
            window.location.href = 'greeting.html';
        }
    });
});


//# sourceMappingURL=child-details.a8744da1.js.map
